<template>
  <div class="form-modal__success-block success-block">
    <div class="success-block__wrapp">
      <div class="success-block__title">
        <div class="success-block__title-text" v-html="title" />
        <Success
          class="success-block__title-icon"
        />
      </div>
    
      <div class="success-block__description" v-html="hintText" />
      <div class="social-network__socials-links">
        <a href="https://www.facebook.com/MastercardUkraine/" target="_blank" class="social-network__socials-link">
          <Facebook />
        </a>
        <a href="https://www.instagram.com/mastercardukraine/" target="_blank" class="social-network__socials-link">
          <Instagram />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import Success from '@/assets/svg/success.svg'
  import Facebook from '@/assets/svg/facebook.svg'
  import Instagram from '@/assets/svg/instagram.svg'
  export default {
    name: 'SuccessBlock',

    components: { Success, Facebook, Instagram },

    props: {
      title: {
        type: String,
        default: ''
      },
      hintText: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss">
.success-block {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
  min-height: 100%;

  &__wrapp {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-left: 100px;

    @include mobile {
      width: 70%;
      padding-left: 20px;
    }
  }

  &__title {
    position: relative;
    font-size: 54px;
    font-weight: 700;
    line-height: 1.18;
    color: $c-medium-black;
    text-transform: uppercase;
    margin-bottom: 18px;

    @include mobile {
      font-size: 24px;
      line-height: 1.18;
      margin-bottom: 16px;
    }

    &-text {
      width: 100%;
      max-width: 520px;
    }

    &-icon {
      position: absolute;
      top: -40px;
      left: -90px;
      z-index: -1;
      width: 195px;
      height: 131px;

      @include mobile {
        top: -30px;
        left: -45px;
        width: 96px;
        height: 64px;
      }
    }
  }

  &__description {
    font-size: 18px;
    line-height: 1.34;
    color: $c-light-black;
    margin-bottom: 32px;
    width: 100%;
    max-width: 332px;

    @include mobile {
      font-size: 13px;
      line-height: 18px;
      margin-bottom: 16px;
    }
  }

  .social-network__socials-links {
    margin-left: 0;

    @include mobile {
      text-align: left;
      margin-top: 0;
    }

    svg {
      width: 32px;
      height: 32px;

      @include mobile {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
